import React from "react";
import { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";

import { useStoreState, useStoreActions } from "react-flow-renderer";
import { updateConditionalNodeEdge } from "../../../state/undoFlow/actions";

import {
  Header,
  Container,
  Description,
  TimerInput,
  InputContainer,
  Label,
  EdgesContainer,
} from "./styles";

import Popper from "../../../components/general/Popper";
import IterableEdges from "./IterableEdges";

const ConditionalPopper = ({
  isOpen,
  onClose,
  node,
  anchorRef,
  inicialText,
}) => {
  const [text, setText] = useState(inicialText);
  const setSelectedElements = useStoreActions(
    (actions) => actions.setSelectedElements
  );

  const anchor = useRef(anchorRef);
  const dispatch = useDispatch();
  const nodeId = node.id;

  const allEdges = useStoreState((state) => state.edges);
  const startingEdges = allEdges.filter((edge) => edge.source === nodeId);
  const [markerPosition, setMarkerPosition] = useState({
    pos: `50%`,
    above: true,
  });

  const [inputs, setInputs] = useState(
    Array(startingEdges.length)
      .fill()
      .map((_, index) => ({
        id: startingEdges[index]?.id,
        text: startingEdges[index]?.data.text,
        type: "customEdge",
      }))
  );

  const validation = async () => {
    let payload = [];
    if (text !== inicialText && text !== "") {
      payload.push({ id: nodeId, text, type: "customNode" });
    }

    const modifiedEdges = inputs.filter(
      (value, index) =>
        value.text !== startingEdges[index].data.text && value.text !== ""
    );
    const finalPayload = [...payload, ...modifiedEdges];
    if (finalPayload.length > 0) {
      dispatch(updateConditionalNodeEdge(finalPayload));
    }
  };

  const handleClose = async () => {
    await validation().then(() => onClose());
  };

  const handleInputSelect = (data) => {
    if (typeof data.id !== "string") {
      console.error("ID must be a string", data.id);
      return;
    }
    const parts = data.id.split("-");
    if (parts.length < 5) {
      console.error("ID is not in the expected format", data.id);
      return;
    }
    const selectedEdge = {
      id: data.id,
      source: parts[1],
      target: parts[2],
      type: data.type,
      sourceHandle: parts[3],
      targetHandle: parts[4],
      data: {
        text: data.text,
        status: "pending",
      },
    };
    setSelectedElements([selectedEdge]);
  };

  const handleMainInputSelect = (node) => {
    setSelectedElements([node]);
  };

  useEffect(() => {
    return () => {
      setSelectedElements([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Popper
      isOpen={isOpen}
      onClose={handleClose}
      anchorRef={anchor}
      width={300}
      height={inputs.length === 2 ? 250 : inputs.length === 3 ? 280 : 300}
      setMarkerPosition={setMarkerPosition}
      markerSize={14}
    >
      <Container
        markPosition={markerPosition.pos}
        isAbove={markerPosition.above}
      >
        <Header>
          {/*<TimerPopperIcon />*/}
          <span>Editar Condicional</span>
        </Header>
        <Description>
          Defina o nome da Decisão e as possiveis respostas esperadas
        </Description>
        <InputContainer>
          <Label>Condicional:</Label>
          <TimerInput
            type="text"
            value={text.toUpperCase()}
            onChange={(e) => {
              e.preventDefault();
              const pointer = e.target.selectionStart;

              window.requestAnimationFrame(() => {
                e.target.selectionStart = pointer;
                e.target.selectionEnd = pointer;
              });
              setText(e.target.value.toUpperCase());
            }}
            onFocus={() => handleMainInputSelect(node)}
          />
        </InputContainer>
        <EdgesContainer>
          {inputs.length > 0
            ? inputs.map((item, index) => (
                <IterableEdges
                  key={index}
                  number={index}
                  item={item}
                  edges={inputs}
                  setEdges={setInputs}
                  onInputSelect={() => handleInputSelect(item)}
                />
              ))
            : null}
        </EdgesContainer>
      </Container>
    </Popper>
  );
};

export default ConditionalPopper;
